import { CartPage } from '@/pages/buyer/CartPage';
import { DesktopCartPage } from '@/pages/desktop/DesktopCartPage';
import { BottomNavigation } from '@/components/common/BottomNavigation';

export function ResponsiveCartPage() {
  return (
    <>
      {/* Mobile version */}
      <div className="lg:hidden">
        <div className="mobile-container bg-white min-h-screen relative">
          <CartPage />
          <BottomNavigation activeId="cart" />
        </div>
      </div>
      
      {/* Desktop version */}
      <div className="hidden lg:block">
        <DesktopCartPage />
      </div>
    </>
  );
}